const STORAGE_SESSION_ID_KEY = "sessionId";

function generateRandomId(): string {
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  return array[0].toString(36).padStart(18, "0").slice(0, 18);
}

function generateRandomGUID(): string {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replaceAll(/[xy]/g, function (c) {
    const array = new Uint8Array(1);
    crypto.getRandomValues(array);
    const r = array[0] % 16;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function getCookieValue(name: string): string | null {
  const regex = new RegExp(`(?:^|; )${name}=([^;]*)`);
  const match = regex.exec(document.cookie);
  return match ? decodeURIComponent(match[1]) : null;
}

export function initializeSessionId({
  storageSessionIdKey = STORAGE_SESSION_ID_KEY,
  uuid = false,
}): string {
  try {
    const sessionId =
      getCookieValue(storageSessionIdKey) ??
      sessionStorage.getItem(storageSessionIdKey) ??
      (uuid ? generateRandomGUID() : generateRandomId());

    sessionStorage.setItem(storageSessionIdKey, sessionId);

    return sessionId;
  } catch {
    return "";
  }
}

export function getSessionId(args?: { storageSessionIdKey?: string }) {
  try {
    const { storageSessionIdKey } = args || {};

    return sessionStorage.getItem(storageSessionIdKey ?? STORAGE_SESSION_ID_KEY) as string;
  } catch {
    return "";
  }
}
